import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useState, useEffect } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, Col, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import { CardFooter, } from "reactstrap";
import WeekTable from './WeekTable';
import MaandoverzichtTable from './MaandoverzichtTable';
import PeriodeOverzicht from './PeriodeOverzicht';
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useOverview } from "Api/Vervanger/Overview";


const Default = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [communityId, setCommunityId] = useState('all');
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!startDate && !endDate) {
            intiDates();
        }
    }, []);

    const {
        data: overviewResponse,
        isLoading,
        mutate: refreshOverview,
    } = useOverview(
        startDate
            ? moment(startDate).format("DD-MM-yyyy")
            : "",
        endDate
            ? moment(endDate).format("DD-MM-yyyy")
            : "",
        communityId
    );

    const data = overviewResponse?.data || {};

    const intiDates = async () => {
        const date = new Date();
        const currentDate = moment(date).format('MM/DD/yyyy');
        let year = date.getFullYear();
        let endDate2 = '';
        let beginDate = '08/01/' + year;

        if (currentDate < beginDate) {
            year = date.getFullYear() - 1;
        }
        beginDate = '08/01/' + year;
        let nextYear = year + 1;
        endDate2 = '07/31/' + nextYear;
        setStartDate(beginDate);
        setEndDate(endDate2);
    }


    const saveStartDate = (date) => {
        setStartDate(moment(date).format("MM/DD/YYYY"));
    }

    const saveEndDate = (date) => {
        setEndDate(moment(date).format("MM/DD/YYYY"));
    }

    const saveCommunityId = (value) => {
        setCommunityId(value);
        isOpen();
    }

    const isOpen = () => {
        if (show === false) {
            setShow(true);
        } else {
            setShow(false);
        }
    }


    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="12">
                            <PeriodeOverzicht arrTotal={data.arrTotal !== undefined ? data.arrTotal : []}
                                communityList={data.bestuur !== undefined ? data.bestuur : []}
                                saveStartDate={saveStartDate} saveEndDate={saveEndDate}
                                startDate={startDate} endDate={endDate}
                                saveCommunityId={saveCommunityId}

                            />
                        </Col>
                        <Col md="12">
                            <Card className="main-card mb-3">
                                <CardBody>
                                    <h6 class="head-text-color mb-2" style={{ fontWeight: 600 }}>Maandoverzicht</h6>
                                    <Col md="6">
                                        <MaandoverzichtTable arrMonth={data.arrMonth !== undefined ? data.arrMonth : []} />
                                    </Col>
                                </CardBody>
                            </Card>
                        </Col>
                        {data.arrWeek !== undefined && Object.keys(data.arrWeek).length > 0 && <Col md="12">
                            <Card className="main-card">
                                <CardBody className="table-responsive">
                                    <h6 class="head-text-color mb-3" style={{ fontWeight: 600 }}>Weekoverzicht</h6>
                                    {data.arrWeek !== undefined && Object.keys(data.arrWeek).map(function (list) {
                                        return (
                                            <WeekTable weekno={list} list={data.arrWeek[list]} sum={data.arrWeekSum[list] !== undefined ? data.arrWeekSum[list] : null} />
                                        )
                                    })}
                                </CardBody>
                            </Card>
                        </Col>}
                    </Row>
                </div>
            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <div className="d-flex gap-2">
                        <div className="selectBy">
                            <select
                                className="form-select"
                                onChange={(event) => saveCommunityId(event.target.value)}
                                aria-label="Select schools by name"
                            >
                                <option value="">Alle Besturen</option>
                                {data.bestuur && data.bestuur.length > 0 && data.bestuur.map((value) => {
                                    return (
                                        <option value={value.iCommunityId} key={value.iCommunityId}>
                                            {value.name || ''}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="customDatePicker" >
                            <DatePicker
                                locale="nl"
                                className=" form-control"
                                dateFormat="dd-MM-yyyy"
                                selected={startDate ? new Date(startDate) : null}
                                onChange={(date) => saveStartDate(date)}
                                placeholderText="Selecteer begindatum"
                            />
                            <FontAwesomeIcon
                                icon={faCalendarAlt}
                                className="datepicker-icon-FontAwesome"
                            />

                        </div>
                        <div className="customDatePicker">
                            <DatePicker
                                className="form-control"
                                locale="nl"
                                dateFormat="dd-MM-yyyy"
                                selected={endDate ? new Date(endDate) : null}
                                onChange={(date) => saveEndDate(date)}
                                placeholderText="Selecteer einddatum"
                            />
                            <FontAwesomeIcon
                                icon={faCalendarAlt}
                                className="datepicker-icon-FontAwesome"
                            />

                        </div>
                    </div>
                </CardFooter>
            </div>
        </Fragment>
    )
};

export default Default;